
<div class="w-100">
    <div class="step-title primary--text" style="margin-bottom: 10px;">
        <div>{{ title }}</div>
        <c-site-tzb-rating
            v-if    =" rating"
            v-model = "rating"
            :style  = "'padding-right: ' + this.paddingRight + 'px'"
        />
    </div>
</div>
